const VARIANTS = {
  cert:  'bg-[var(--butter-soft)] text-[var(--butter)] border-[var(--butter-soft)]',
  score: 'bg-[var(--mint-soft)] text-[var(--mint)] border-[var(--mint-soft)]',
  grade: 'bg-[var(--lav-soft)] text-[var(--lav)] border-[var(--lav-soft)]',
  new:   'bg-[var(--sky-soft)] text-[var(--sky)] border-[var(--sky-soft)]',
  dim:   'bg-[var(--bg-soft)] text-[var(--ink-3)] border-[var(--border)]',
}

export default function Chip({ variant = 'dim', className = '', children, ...props }) {
  return (
    <span
      className={
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] ' +
        'font-semibold tracking-wide border ' + (VARIANTS[variant] ?? VARIANTS.dim) + ' ' + className
      }
      {...props}
    >
      {children}
    </span>
  )
}
